// extracted by mini-css-extract-plugin
module.exports = {"sizes":"'./../../variables.css'","xl":"1280px","container":"style-module--container--2Fc52"};